module.exports = __webpack_public_path__ + "static/media/dod-2.1a55851f.gif";